
class BlurPanel {
    setBlur(visible : boolean){
        const blur = document.getElementById("blurPanel");
          if (blur != null && visible) 
            blur.style.display = 'block';
          else if (blur != null && !visible)
            blur.style.display = 'none';
          
    }
}
const blurPanel = new BlurPanel();
export default blurPanel;
